import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { createSelector } from 'reselect'; //memoization
import { entrySubTypes } from './AutoCompleteData';

const REO_SUB_TYPES = ['REOC', 'REOS', 'REOSC'];

//memoization -  cached result when the same inputs occur again
const lazyEntrySubType = createSelector(
  (value) => (async () => await lazyEntrySubTypePromise(value))(),
  (returnValue) => returnValue
);

async function lazyEntrySubTypePromise(value) {
  return new Promise((resolve, reject) => {
    resolve(value);
  });
}

export default function SelectSubEntryType(props) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [inputValue, setInputValue] = React.useState(props.value);

  const setPropsValue = (value) => {
    props.onChange({
      currentTarget: {
        name: props.name,
        value: value,
      },
      target: {
        name: props.name,
        value: value,
      },
    });
  };

  const handleOnBlur = async (value) => {
    if (props.freeSolo) {
      setPropsValue(value);
      return;
    }

    if (options.find((o) => o.code === value)) {
      setPropsValue(value);
      return;
    }

    // if selected value does not exist in options and is not a free solo
    setInputValue('');
    setPropsValue('');
  };

  //set local input value and get options
  const handleInputChange = async (event, value) => {
    if (!event) return;
    if (event.type === 'blur') return;
    if (event.type === 'click' && value) return;

    setInputValue(value);
    setPropsValue(value);
    getOptions(value);
  };

  //get list from backend
  const getOptions = async (value) => {
    const list = await lazyEntrySubType(entrySubTypes);
    const filtered = list.filter((et) => {
      if (!et.code) return false;
      if (props.entryType === 'REO') return REO_SUB_TYPES.includes(et.code);
      return true;
    });
    setOptions(filtered);
  };

  React.useEffect(() => {
    if (open) {
      getOptions(props.value);
    }
  }, [open, props]);

  return (
    <Autocomplete
      disabled={props.disabled}
      freeSolo={props.freeSolo}
      id={props.name}
      onInputChange={handleInputChange}
      onBlur={() => {
        handleOnBlur(inputValue);
      }}
      blurOnSelect={false}
      onChange={(_, v) => {
        const value = v ? v.code : '';
        setPropsValue(value);
        setInputValue(value);
      }}
      getOptionSelected={(option, value) => option.code === value.code}
      getOptionLabel={(option) => option.code}
      inputValue={inputValue}
      options={options}
      name={props.name}
      autoHighlight={true}
      clearOnEscape={true}
      onClose={() => {
        setOpen(false);
      }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          name={props.name}
          required={props.required}
          disabled={props.disabled}
          label={props.label}
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  );
}
